import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueNotifications from 'vue-notifications'
import iziToast from 'izitoast'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import moment from 'moment'

// Bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'vue-datetime/dist/vue-datetime.css'

import 'izitoast/dist/css/iziToast.min.css'

Vue.use(BootstrapVue)
Vue.component('icon', Icon)

function toast ({ title, message, type, timeout, cb }) {
    if (type === VueNotifications.types.warn) type = 'warning'
    return iziToast[type]({ title, message, timeout, position: 'topRight' })
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}

Vue.use(VueNotifications, options)

Vue.config.productionTip = false

Vue.filter('date', function (value) {
    if (!value) return ''
    return moment.utc(value).format("MMM Do YYYY")
})

Vue.filter('time', function (value) {
    if (!value) return ''
    return moment.utc(value).format("h:mm A")
})

Vue.filter('monthYear', function (value) {
    if (!value) return ''
    return moment.utc(value).format("MMMM YYYY")
})

Vue.filter('datetime', function (value) {
    if (!value) return ''
    return moment.utc(value).format("MMM Do YYYY [at] h:mm A")
})

store.commit('SET_BASE_API_URL', Vue.http.options.root)
store.dispatch('loadGoogleClientId')

if (localStorage.getItem('id_token')) {
    store.dispatch('isTokenValid')
    store.dispatch('getUser', localStorage.getItem('id_token'))
}

router.beforeEach((to, from, next) => {
    store.dispatch('isTokenValid')
    next()
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js